import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["input", "hiddenInput"]

    connect() {
        this.autoSubmitLock = false
        if (this.hasInputTarget) {
            this.inputTargets[0]?.focus()
        }
    }

    onInput(event) {
        const currentInput = event.target
        const currentIndex = this.inputTargets.indexOf(currentInput)
        const digits = currentInput.value.replace(/\D/g, '')

        if (digits.length > 1) {
            this.fillOtpFromDigitString(digits)
            return
        }

        if (currentInput.value.length === 1 && currentIndex >= 0 && currentIndex < this.inputTargets.length - 1) {
            this.inputTargets[currentIndex + 1].focus()
        }

        this.updateHiddenInput()
        this.maybeAutoSubmit()
    }

    onKeyDown(event) {
        if (event.key === 'Backspace' && event.target.value.length === 0) {
            const currentIndex = this.inputTargets.indexOf(event.target)
            if (currentIndex > 0) {
                this.inputTargets[currentIndex - 1].focus()
            }
        }
    }

    onPaste(event) {
        event.preventDefault()
        const pastedData = (event.clipboardData || window.clipboardData).getData('text')
        this.fillOtpFromDigitString(pastedData)
    }

    fillOtpFromDigitString(raw) {
        const digits = String(raw).replace(/\D/g, '').slice(0, 6)
        const chars = digits.split('')

        this.inputTargets.forEach((input, index) => {
            input.value = chars[index] || ''
        })

        const lastIndex = Math.min(Math.max(chars.length - 1, 0), this.inputTargets.length - 1)
        this.inputTargets[lastIndex].focus()
        this.updateHiddenInput()
        this.maybeAutoSubmit()
    }

    maybeAutoSubmit() {
        if (this.autoSubmitLock) {
            return
        }

        const otpValue = this.inputTargets.map((input) => input.value).join('')
        if (otpValue.length !== 6 || !/^\d{6}$/.test(otpValue)) {
            return
        }

        this.autoSubmitLock = true
        queueMicrotask(() => {
            this.element.requestSubmit()
        })
    }

    updateHiddenInput() {
        const otpValue = this.inputTargets.map(input => input.value).join('')
        this.hiddenInputTarget.value = otpValue
    }

    clearInputs() {
        this.autoSubmitLock = false
        // Clear all OTP input fields
        this.inputTargets.forEach(input => {
            input.value = ''
        })
        // Clear the hidden input
        if (this.hasHiddenInputTarget) {
            this.hiddenInputTarget.value = ''
        }
        // Focus on first input
        if (this.hasInputTarget) {
            this.inputTargets[0]?.focus()
        }
    }
}
